import { Component } from "react";
import { connect } from "react-redux";
import { BetSlipHelper } from "../../../../../../../../../../../helpers/betSlipHelper";
import type {
  EventMarketType,
  EventType,
} from "../../../../../../../../../../../types/eventType";
import RenderOddsComponent from "../RenderOddsComponent/RenderOddsComponent";
import "./Runner.scss";
type Props = {
  event: EventType;
  market: EventMarketType;
  marketType: Record<string, any>;
  addBetSlip: (...args: Array<any>) => any;
  runner: Record<string, any>;
  index: number;
};

class Runner extends Component<Props> {
  addBetSlip = (runner: Record<string, any>) => {
    let betSlip = BetSlipHelper.prepareBetSlip(this.props.event, runner);
    this.props.addBetSlip(betSlip);
  };

  render() {
    const { event, marketType, runner } = this.props;
    return (
      <>
        <span // key={"binary" + runner.id + index}
          onClick={() => {
            this.addBetSlip(runner);
          }}
          className={"modal-runner"}
        >
          <div className={"modal-runner__name"}>{runner.name}</div>
          <RenderOddsComponent
            event={event}
            runner={runner}
            marketType={marketType}
          />
        </span>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addBetSlip: (betSlip: EventType) =>
      dispatch.betSlipListModel.addBetSlip(betSlip),
  };
}

export default connect(null, mapDispatchToProps)(Runner) as any;
